// extracted by mini-css-extract-plugin
export default {"page":"page_page__DwIsk","filtersPay":"page_filtersPay__nk8BA","filterPay":"page_filterPay__enu1O","filtersPayNew":"page_filtersPayNew__TpGaO"};